import { NotrufResponseObj, NotrufResponseObjAddress } from "./WhatsAppBot";

export type NotrufEntry = NotrufResponseObj | NotrufResponseObjAddress;

export class Backend {

    private static debug = window.location.port === "3000";
    public static URL: string = Backend.debug ?
        "http://" + window.location.host.substring(0, window.location.host.indexOf(":")) + ":8434/external"
        : "https://stoerung.icvg-online.de/api";

    public static sendRequest(method: string, endpoint: string, data?: any, expectedCode: number = 200): Promise<any> {
        let body = data ? { body: JSON.stringify(data) } : {};

        return fetch(Backend.URL + endpoint, {
            method: method,
            headers: {
                "Accept": "application/json"
            },
            ...body
        }).then(response => {
            if (response.status === expectedCode || expectedCode === -1) {
                return response.json();
            }
            else throw response;
        });
    }
}